const INIT_OPTIONS = {
}

const CSS_ACTIVE = 'active';
const SELECTOR_PIN_WRAPPER = '.ab-miv-pin-wrapper ';
const SELECTOR_BTN = '.ab-miv-btn';

class ABMapInteractiveViewerCore {
	target;
	options;


    constructor(target, options) {
        this.target = this.getTarget(target);
		this.options = this.getOptions(options);
    }

	getOptions(options) {
        const newOpt = Object.assign({}, INIT_OPTIONS, options);
        return newOpt;
    }
    getTarget(target) {
        if (typeof target === 'string') {
            return document.querySelector(target);
        }
        return target;
    }	

	init() {

		this.bindEvents();
	}

	bindEvents() {
		const btns = this.getButtons();
		btns.forEach(btn => {
			btn.addEventListener('click', this.onBtnClick);
		});
	}
	unbindEvents() {		
	}

	getButtons() {
		return this.target.querySelectorAll(SELECTOR_BTN);
	}
	getPins() {
		return this.target.querySelectorAll(SELECTOR_PIN);
	}

    togglePins(idGroup) {
        const pins = this.target.querySelectorAll(SELECTOR_PIN_WRAPPER + ' .' + idGroup);
        pins.forEach(pin => pin.classList.toggle(CSS_ACTIVE));
    }

    onBtnClick = (evt) => {
        const target = evt.currentTarget;
        target.classList.toggle(CSS_ACTIVE);
        this.togglePins(target.getAttribute('data-group-id'));
    }
}

class ABMapInteractiveViewer {    
	core;
    constructor(target, options) {
        this.core = new ABMapInteractiveViewerCore(target, options);
    }

	init() {
		this.core.init();
	}
}

window.ABMapInteractiveViewer = ABMapInteractiveViewer;

export default ABMapInteractiveViewer;